import { ITranslationModel } from "@models/interface-management/localization";
import { INestedElement } from "@models/form/base-config";
import { IDicList } from "@models/dictionary/dic-base";

/**
 * Administration API Models
 * Модели для API микросервиса administration.
 */

// Settings
export interface ISetting {
  id: string;
  key: string;
  name: ITranslationModel;
  description: ITranslationModel;
  isRequired: boolean;
  value: string;
  isShowOnInterface: boolean;
  isReadonly: boolean;
  dataType: SettingTypeEnum;
  typeDescription: string;
  isEncrypt: boolean;
  isUnauthorizedAccessAllowed: boolean;
  settingGroup: INestedElement<string, ITranslationModel>;
}

export enum SettingTypeEnum {
  Text = 1,
  LongText = 2,
  Number = 3,
  Checkbox = 4,
  Array = 6,
  Json = 7,
  Enum = 8,
  Dictionary = 10,
  Timespan = 16,
}

export enum SettingEnum {
  ApplicationName = "ApplicationName",
  ActivityFeedIntervalSetting = "ActivityFeedIntervalSetting",
}

export const SettingNoneParsedTypes = [
  SettingTypeEnum.Text,
  SettingTypeEnum.LongText,
  SettingTypeEnum.Number,
  SettingTypeEnum.Enum,
  SettingTypeEnum.Timespan,
];

// Users & Roles
export interface IUserRole {
  id: number;
  name: ITranslationModel;
  homeMenuItem: any;
  homeMenuItemId: number;
  homePage: string;
  normalizedName: string;
  value?: boolean;
  isMainRole?: boolean;
  code: string;
  homePageMenuItemUrl: string | null;
  appPermissions?: number[];
  settings: string;
  settingTooltip: string;
}

export interface IUserPermission {
  name: string;
  description: string;
  value: number;
  module: string;
}

// Menus
export interface IMenuModel {
  id: string;
  name: ITranslationModel;
  slug: string;
}

export interface IMenuItemModel {
  id?: string;
  menuId?: string;
  name?: ITranslationModel;
  url?: string | null;
  parentId?: number;
  parentName?: string;
  weight?: number;
  icon?: string | null;
  children?: IMenuItemModel[];
  isWebShow?: boolean;
  isMobileShow?: boolean;
  appModules: string[];
  appPermissions: number[];
  eventTypeIds: string[];
  targetTypes: string[];
}

export interface IMenuItemBySlugModel {
  id: string;
  name: ITranslationModel;
  url: string;
  icon: string;
  parentId: string;
  parentName: string;
  children: IMenuItemBySlugModel[];
  importanceCount: string;
  criticalCount: string;
  weight: number;
  isDeleted: boolean;
  deletedBy: string;
  deletedAt: string;
}

// Access Settings
export interface IAccessSettings extends IDicList {
  code: string;
  appModules: IAppModuleInfo[];
}

export interface IValueCode {
  value: string;
  code: string;
}

export interface IAppModuleInfo<T extends string | object = object> {
  appModule: T extends string ? string : IValueCode;
  permissionsInfo: T extends string ? string : IPermissionsInfo;
  eventsInfo: T extends string ? string : IEventsInfo;
  notificationsInfo: T extends string ? string : INotificationsInfo;
  id: string;
  value: string;
}

export interface IPermissionsInfo {
  totalPermissionsCount: number;
  enablePermissionsCount: number;
}

export interface IEventsInfo {
  totalEventsCount: number;
  enableEventsCount: number;
}

export interface INotificationsInfo {
  totalNotificationsCount: number;
  enableNotificationsCount: number;
}
